import { render } from "./StockReportsView.vue?vue&type=template&id=0f962a1e&scoped=true"
import script from "./StockReportsView.vue?vue&type=script&lang=js"
export * from "./StockReportsView.vue?vue&type=script&lang=js"

import "./StockReportsView.vue?vue&type=style&index=0&id=0f962a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f962a1e"]])

export default __exports__